import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { ViewActions } from './view.actions';

export const viewFeatureKey = 'view';

export interface ViewState {
  pageTitle: string;
}

export const initialState: ViewState = {
  pageTitle: '',
};

export const viewFeature = createFeature({
  name: viewFeatureKey,
  reducer: createReducer(
    initialState,
    on(ViewActions.viewSetPageTitle, (state, { pageTitle }) => ({
      ...state,
      pageTitle,
    }))
  ),

  extraSelectors: ({ selectViewState }) => ({
    selectPageTitle: createSelector(selectViewState, (selectViewStateData) => selectViewStateData.pageTitle),
  }),
});
